import { render, staticRenderFns } from "./agentOrder.vue?vue&type=template&id=04630e8b&"
import script from "./agentOrder.vue?vue&type=script&lang=js&"
export * from "./agentOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports